const LoginHistory = (state = [], action) => {
    switch (action.type) {
        case 'ADMIN_LOGINHISTORY_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default LoginHistory